import React from 'react';
import PropTypes from 'prop-types';
import FocusTrap from 'focus-trap-react';
import IconClose from '../../../shared/icons/icon-close.svg';


const Modal = function ModalComponent({
  children,
  closeModal,
  displayModal,
  labelledBy,
}) {
  document.body.classList.toggle('modal--open', displayModal);

  if (displayModal) {
    const handleEscape = ({ key }) => {
      if (key === 'Escape') {
        closeModal();
      }
    };

    return (
      <FocusTrap
        focusTrapOptions={{
          initialFocus: '.results-grid__close-button',
        }}
      >
        <div
          role="dialog"
          aria-modal
          aria-labelledby={labelledBy}
          className="results-grid__modal"
          onKeyDown={handleEscape}
        >
          <div className="results-grid__modal-wrapper">
            <button
              className="results-grid__close-button"
              type="button"
              onClick={closeModal}
              aria-label="Close"
            >
              <IconClose className="results-grid__close-icon" />
            </button>
            {children}
          </div>
        </div>
      </FocusTrap>
    );
  }
  return null;
};

Modal.propTypes = {
  children: PropTypes.element.isRequired,
  closeModal: PropTypes.func.isRequired,
  displayModal: PropTypes.bool,
  labelledBy: PropTypes.string,
};
Modal.defaultProps = {
  displayModal: false,
  labelledBy: null,
};

export default Modal;
